import type { TBotConfig } from '~entities/bot';
import { DatadogLogger, LoggerServices } from '~shared/services/logger';

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

const DAY = 60 * 60 * 24;
export const getBot = async (botId: string, params?: RequestInit) => {
	const url = `${apiBase}/ai/configuration/bots/${botId}/`;

	const response = await fetch(url, {
		...params,
		next: {
			revalidate: DAY,
			...params?.next,
			tags: ['bot-any', `bot-${botId}`],
		},
	});
	if (!response.ok) {
		if (response.status !== 404) {
			DatadogLogger.error(
				LoggerServices.PublicBotApiService,
				`Error fetching bot clientId: ${botId}: ${response.status.toString()}`
			);
		}
		throw new Error(`Error fetching bot: ${response.status}`, {
			cause: response.status,
		});
	}
	return (await response.json()) as TBotConfig;
};
